import React, { useState, useEffect } from 'react'
import '../../../styles/consultancy.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Shared/product.css'
// import khand from '../images/product/Khand.jpg'
// import jaggrey from '../images/product/Jaggery.png'
// import amrit from '../images/product/Amrit_Pey.jpg'
import product from '../../../images/product/product.jpg'
import { NavLink } from 'react-router-dom';
import { resolveProductImage } from '../../../utils/resolveProductImage';
import { apiUrl } from '../../../utils/apiBase';

const slugify = (name) => name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');

// const products = [
//   { id: 1, name: "Amrit Pey", description: "Amrit Pey is a unique blend of 14 spices designed to help you overcome coffee and tea addiction.", img: amrit },
//   { id: 2, name: "Khand", description: "Khand is a type of unrefined raw sugar commonly used in Indian cuisine and traditional Ayurvedic preparations.", img: khand },
//   { id: 3, name: "Jaggery", description: "Jaggery is a traditional, unrefined sweetener commonly used in Indian cuisine and Ayurvedic preparations.", img: jaggrey },
// ];


function Product() {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedUnits, setSelectedUnits] = useState({});
  const [selectedPrices, setSelectedPrices] = useState({});

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleUnitChange = (productId, selectedUnit) => {
    setSelectedUnits((prev) => ({
      ...prev,
      [productId]: selectedUnit,
    }));

    // Set price according to the selected unit
    const selectedProduct = products.find((prod) => prod.id === productId);
    const priceKey = `price${selectedUnit === selectedProduct.unit1 ? 1 : selectedUnit === selectedProduct.unit2 ? 2 : 3}`;
    const price = selectedProduct[priceKey];
    setSelectedPrices((prev) => ({
      ...prev,
      [productId]: price,
    }));
  };

  useEffect(() => {
    // Set default prices based on unit1
    const defaultPrices = products.reduce((acc, product) => {
      acc[product.id] = product.price1; // Default to price1 for each product
      return acc;
    }, {});
    setSelectedPrices(defaultPrices); // Set initial prices

  }, [products]);



  useEffect(() => {
    AOS.init({ duration: 1500, easing: 'ease-in-out' });
  }, []);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after content is loaded
    }, 1500); // Adjust time as needed

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, []);

  useEffect(() => {
    fetch(apiUrl('anuyog-products-list/'))
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        const list = Array.isArray(data) ? data : (data.data ?? data.results ?? []);
        const fetchedProducts = list.map((product) => ({
          id: product.id,
          name: product.name,
          description: product.description,
          price1: product.price1,
          price2: product.price2,
          price3: product.price3,
          unit1: product.unit1,
          unit2: product.unit2,
          unit3: product.unit3,
          category: product.category,
          img: resolveProductImage(product.image),
        }));
        const categories = [...new Set(list.map((product) => product.category))];
        const defaultUnits = {};
        const defaultPrices = {};
        fetchedProducts.forEach((product) => {
          defaultUnits[product.id] = product.unit1;
          defaultPrices[product.id] = product.price1;
        });

        setProducts(fetchedProducts);
        setCategories(categories);
        setSelectedUnits(defaultUnits);
        setSelectedPrices(defaultPrices);
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      });
  }, []);

  const filteredProducts = selectedCategory
    ? products.filter((product) => product.category === selectedCategory)
    : products;



  return (
    <>
      {/* Loader */}
      {loading && <div className="loader-container">
        <div className="loader"></div>
        <img src="/images/logo192.png" alt="Anuyog Icon" className="loader-icon" />
      </div>}


      {!loading && (
        <>

          <section className='product-banner-section'>
            <div className="product-banner">
              <img src={product} alt="" />
              <h1 className='consultancy-heading  '>"Food is medicine—when you eat right, it heals"</h1>

            </div>
          </section>



          <section className='choose-section'>
            <div className="container">
              <div className="choose">
                <div className="work">




                  <div className="work-text mb-4" >
                    <h3
                      className='fonts text-center text-dark mb-4 fw-bold offering-title'
                      style={{ maxWidth: '930px', margin: '0 auto' }}
                    >
                      Our goal is to provide you with
                      <strong style={{ color: '#9D3B24' }}> carefully chosen products </strong> that empower your
                      <strong style={{ color: '#9D3B24' }}> natural living journey
                      </strong> to a <strong style={{ color: '#9D3B24' }}> healthier, sustainable lifestyle
                      </strong>

                    </h3>
                  </div>

                </div>
                <p className='text-center mb-4'><strong style={{ color: '#000', maxWidth: '630px', display: 'block', margin: '0 auto' }}> We place high value on consuming adulteration-free products for a healthier lifestyle and strive to uphold the following commitments. However, as not everything is within our control, we kindly ask for your understanding in advance for any service inconveniences.</strong>
                </p>
                <div className="offerings">
                  <div className="all_offers" data-aos="zoom-in" data-aos-duration="1000">

                    <div className="offers">
                      <div className="offering-icon">
                        <img src="images/quality.png" alt="" />
                      </div>


                      <div className="offering-text">
                        <h4 className='fw-bold mt-2'>BEST QUALITY</h4>
                        <p > We source and deliver only the highest-quality products, crafted to meet rigorous standards of excellence.</p>
                      </div>

                    </div>

                    <div className="offers">
                      <div className="offering-icon">
                        <img src="images/natural.png" alt="" />
                      </div>


                      <div className="offering-text">
                        <h4 className='fw-bold mt-2'>100% NATURAL</h4>
                        <p > Our products are free from artificial additives, ensuring you receive only wholesome, natural ingredients.</p>
                      </div>

                    </div>


                    <div className="offers">
                      <div className="offering-icon">
                        <img src="images/pure-and-clean.png" alt="" />
                      </div>


                      <div className="offering-text">
                        <h4 className='fw-bold mt-2'> PURE AND CLEAN</h4>
                        <p > We ensure that our product retain their full nutritional value and purity.</p>
                      </div>

                    </div>


                    <div className="offers">
                      <div className="offering-icon">
                        <img src="images/trust02.png" alt="" />
                      </div>


                      <div className="offering-text">
                        <h4 className='fw-bold mt-2'> TRUSTIFIED</h4>
                        <p >We ensure that you can trust every product we offer.</p>
                      </div>

                    </div>



                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className='how-purchase-section pillar-section'>
            <div className="container">
              <div className="pillar">
                <h2 className='mb-4 offering-title'><strong style={{ color: '#9D3B24' }}>How to Purchase?</strong></h2>
              </div>
              <div className="all-pillar">
                <div className="pillar-detail" data-aos="fade-up" data-aos-duration="3000">
                  <div className="pillar-image">

                    <img src='/images/select.png' alt="" />
                  </div>
                  <div className="pillar-text">
                    <h5 className='fw-bold'>1. Select Items </h5>
                    <h6 className='fw-bold'>Note down the products you want.
                    </h6>

                  </div>
                </div>

                <div className="line-shape1">
                  <img src="/images/line-shape01.png" alt="" />
                </div>

                <div className="pillar-detail" data-aos="fade-down" data-aos-duration="3000">
                  <div className="pillar-image">
                    <div>
                      <img src='/images/submit.png' alt="" />
                    </div>
                  </div>

                  <div className="pillar-text">
                    <NavLink
                      to="/contact"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <h5 className='fw-bold'>2. Submit Order</h5>
                    </NavLink>
                    <h6 className='fw-bold'>Go to Contact Us, fill in the form and share your order. </h6>

                  </div>



                </div>
                <div className="line-shape2">
                  <img src="/images/line-shape02.png" alt="" />
                </div>
                <div className="pillar-detail" data-aos="fade-up" data-aos-duration="3000">
                  <div className="pillar-image">

                    <img src='./images/confirm.png' alt="" />

                  </div>
                  <div className="pillar-text">
                    <h5 className='fw-bold'>3. Confirm Details</h5>
                    <h6 className='fw-bold'>We’ll call you to confirm total amount including delivery fees.</h6>
                  </div>
                </div>
                <div className="line-shape1">
                  <img src="/images/line-shape01.png" alt="" />
                </div>
                <div className="pillar-detail" data-aos="fade-down" data-aos-duration="3000">
                  <div className="pillar-image">
                    <div>
                      <img src='./images/pay.png' alt="" />
                    </div>
                  </div>
                  <div className="pillar-text">
                    <h5 className='fw-bold'>4. Pay</h5>
                    <h6 className='fw-bold'>Complete your payment. </h6>
                  </div>
                </div>
                <div className="line-shape2">
                  <img src="/images/line-shape02.png" alt="" />
                </div>
                <div className="pillar-detail" data-aos="fade-up" data-aos-duration="3000">
                  <div className="pillar-image">
                    <img src='./images/dispatch.png' alt="" />
                  </div>
                  <div className="pillar-text">
                    <h5 className='fw-bold'>5. Dispatch</h5>
                    <h6 className='fw-bold'>We’ll dispatch your items once payment is received.</h6>

                  </div>
                </div>
              </div>
              <div className="how mt-5">
                <NavLink
                  to="/contact"
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  <button type="button" className="btn">Buy Now</button>
                </NavLink>
              </div>
            </div>

          </section>
          <section className="product-section">
            <div className="container">
              <div className="product">
                <div className="product-filter d-flex justify-content-center align-items-center position-relative mb-5">
                  
                  <h1 className="offering-title text-center flex-grow-1">OUR PRODUCTS</h1>

                  
                  <select
                    id="categoryFilter"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    className="form-control custom-dropdown end-0"
                  >
                    <option value="">Select Product Categories</option>
                    {categories.map((category, index) => (
                      <option key={index} value={category}>
                        {category}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="row">
                  {filteredProducts.length > 0 ? (
                    filteredProducts.map((product) => (
                      <div className="col-md-4" key={product.id}>
                        <div className="card" style={{ width: '18rem' }}>
                          <NavLink to={product.name === "Amrit Pey" ? `/products/${slugify(product.name)}` : "/contact"} onClick={() => window.scrollTo(0, 0)}>
                            <img src={product.img} className="card-img-top img-product" alt={product.name} />
                          </NavLink>
                          <div className="card-body product-body">
                            <NavLink to={product.name === "Amrit Pey" ? `/products/${slugify(product.name)}` : "/contact"} onClick={() => window.scrollTo(0, 0)}>
                              <h5 className="card-title fw-bold">{product.name}</h5>
                            </NavLink>
                            <p className="card-text">{product.description}</p>

                            <div className="price-dropdown">
                              <div className="unit-dropdown">
                                <select
                                  value={selectedUnits[product.id] || product.unit1}
                                  onChange={(e) => handleUnitChange(product.id, e.target.value)}
                                  className="form-control custom-dropdown"
                                >
                                  {product.unit1 && <option value={product.unit1}>{product.unit1}</option>}
                                  {product.unit2 && <option value={product.unit2}>{product.unit2}</option>}
                                  {product.unit3 && <option value={product.unit3}>{product.unit3}</option>}
                                </select>
                              </div>

                              <p className="card-price">
                                <strong>{selectedUnits[product.id] === product.unit1 ? `₹ ${selectedPrices[product.id] || product.price1}` : ''}</strong>
                                <strong>{selectedUnits[product.id] === product.unit2 ? `₹ ${selectedPrices[product.id] || product.price2}` : ''}</strong>
                                <strong>{selectedUnits[product.id] === product.unit3 ? `₹ ${selectedPrices[product.id] || product.price3}` : ''}</strong>
                              </p>
                            </div>

                            <NavLink to={product.name === "Amrit Pey" ? `/products/${slugify(product.name)}` : "/contact"} onClick={() => window.scrollTo(0, 0)} className="btn btn-primary mt-4">
                              BUY NOW
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12">
                      <p>No products found.</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="note">
                <h5 className="mt-5">
                  <strong style={{ color: '#9D3B24' }}>
                    Note: If your product meets our standards and can benefit others, get in touch with us!
                  </strong>
                </h5>

                <h4 className='fw-bold mt-5'>Important Note</h4>
                <h5>
                  <strong style={{ color: '#9D3B24' }}>
                    1) The charges mentioned on the website do not include the delivery fee
                  </strong>
                </h5>
                <h5>
                  <strong style={{ color: '#9D3B24' }}>
                    2)  Please read our Terms and Conditions for Returns & Refunds.
                  </strong>
                </h5>
              </div>
            </div>
          </section>
        </>
      )}

    </>
  )
}

export default Product
